import React from 'react'
import { Phone } from 'lucide-react'

function AboutUs() {
  return (
    <div id='AboutUs'>
        <div className='md:mt-24 mt-8 flex flex-col md:flex-row gap-8 md:gap-12 lg:gap-24 justify-center items-center px-4 md:px-0'>
            {/* Image Section */}
            <div className='w-full md:w-1/2 flex justify-center'>
                <img 
                    src='/image/AbputPageFood.png' 
                    alt='About Us Food'
                    className='w-full max-w-md md:max-w-none md:w-[500px] lg:w-[600px] xl:w-[700px] h-[250px] sm:h-[300px] md:h-[400px] lg:h-[550px] xl:h-[650px] object-cover rounded-2xl'
                />
            </div>
            
            {/* Content Section */}
            <div className='flex flex-col gap-4 md:gap-6 lg:gap-8 w-full md:w-1/2 text-center md:text-left'>
                <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-handwriting text-[#FFA300]'>
                    About Us
                </h1>
                <h1 className='text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-[#16B97A] signika font-bold'>
                    Meal Prep
                </h1>
                <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-5xl alata font-bold'>
                    Indoor & Outdoor Catering
                </h1>
                
                <div className='space-y-4'>
                    <p className='quicksand text-gray-400 text-sm sm:text-base md:text-lg max-w-2xl mx-auto md:mx-0'>
                        We make amazing food ranging from African to American and everything in between.
                        We have been cooking for over 10 years and We love to share great taste with others.
                    </p>
                    <p className='quicksand text-gray-400 text-sm sm:text-base md:text-lg max-w-2xl mx-auto md:mx-0'>
                        I have services ranging from meal prep, in house and outdoor catering and cooking classes. 
                        I am also available for private events and parties.
                    </p>
                </div>

                {/* Stats Section */}
                <div className='flex justify-center md:justify-start gap-4 sm:gap-8 md:gap-12 lg:gap-16 mt-4'>
                    <div className='flex flex-col items-center gap-1 md:gap-2'>
                        <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl signika font-bold text-[#16B97A]'>500+</h1>
                        <p className='text-xs sm:text-sm md:text-md alata'>Happy Customers</p>
                    </div>
                    <div className='flex flex-col items-center gap-1 md:gap-2'>
                        <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl signika font-bold text-[#16B97A]'>2k+</h1>
                        <p className='text-xs sm:text-sm md:text-md alata'>Meals Served</p>
                    </div>
                    <div className='flex flex-col items-center gap-1 md:gap-2'>
                        <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl signika font-bold text-[#16B97A]'>20+</h1>
                        <p className='text-xs sm:text-sm md:text-md alata'>Events</p>
                    </div>
                </div>

                {/* Call to Action Button */}
                <div className='flex justify-center md:justify-start mt-6 md:mt-4'>
                    <button className='bg-[#FFA300] gap-2 text-sm sm:text-base md:text-lg lg:text-2xl flex items-center justify-center w-full sm:w-[160px] md:w-[180px] h-[50px] md:h-[60px] lg:h-[70px] font-bold cursor-pointer rounded-tl-xl rounded-br-3xl hover:bg-[#16B97A] transition-all duration-300 text-white px-4 py-3 md:px-4 md:py-4'>
                        <p>Call Us</p>
                        <Phone size={20} className='md:size-6' />
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutUs